<p-toast></p-toast>
<div class="container-fluid container-fullw">
  <div class="p-fluid p-grid">
    <div class="p-col-12">
      <div>
        <p-fieldset [toggleable]="true">
          <ng-template pTemplate="header">
            <span *ngIf="fitnessClass.id === null">{{ 'NEWFITNESSCLASS' | translate }}</span>
            <span *ngIf="fitnessClass.id !== null">{{ 'EDITFITNESSCLASS' | translate }}</span>
          </ng-template>
          <form pFocusTrap name="fitnessClassForm" id="fitnessClassForm" novalidate (ngSubmit)="submitForm(true)" [formGroup]="fitnessClassForm" >
            <input type="hidden" name="id" id="fitnessClassId" formControlName="id" />
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-tag"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="fitnessClassName" formControlName="name" type="text" pInputText [required]="true"> 
                      <label for="fitnessClassName" class="req">{{ 'NAME' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="fitnessClassForm.controls['name'].invalid && (fitnessClassForm.controls['name'].dirty || fitnessClassForm.controls['name'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="fitnessClassForm.controls['name'].errors !== null">
                  <div *ngIf="fitnessClassForm.controls['name'].errors.required">
                   {{ 'NAMEREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="fitnessClassNameAr" formControlName="nameAr" type="text" pInputText [required]="false"> 
                      <label for="fitnessClassNameAr" class="">{{ 'NAMEAR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="fitnessClassNameFr" formControlName="nameFr" type="text" pInputText [required]="false"> 
                      <label for="fitnessClassNameFr" class="">{{ 'NAMEFR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-image"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="fitnessClassPicture" formControlName="picture" type="text" pInputText [required]="false"> 
                      <label for="fitnessClassPicture" class="">{{ 'PICTURE' | translate }}</label>
                    </span>
                    <button type="button" pButton pRipple icon="pi pi-folder" styleClass="p-button-info" (click)="openFilerDialog('picture')"></button> 
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-mobile"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="fitnessClassMobilePicture" formControlName="mobilePicture" type="text" pInputText [required]="false"> 
                      <label for="fitnessClassMobilePicture" class="">{{ 'MOBILEPICTURE' | translate }}</label>
                    </span>
                    <button type="button" pButton pRipple icon="pi pi-folder" styleClass="p-button-info" (click)="openFilerDialog('mobilePicture')"></button> 
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-tags"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="fitnessClassTitle" formControlName="title" type="text" pInputText [required]="false"> 
                      <label for="fitnessClassTitle" class="">{{ 'TITLE' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-tags"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="fitnessClassTitleAr" formControlName="titleAr" type="text" pInputText [required]="false"> 
                      <label for="fitnessClassTitleAr" class="">{{ 'TITLEAR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-tags"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="fitnessClassTitleFr" formControlName="titleFr" type="text" pInputText [required]="false"> 
                      <label for="fitnessClassTitleFr" class="">{{ 'TITLEFR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-12">

                <div class="p-field p-col-12">
                    <label for="fitnessClassContent" class="">{{ 'CONTENT' | translate }}</label>
                    <ckeditor formControlName="content" [editor]="Editor" id="fitnessClassContent" name="content" [config]="editorService.config"></ckeditor>
                </div>

              </div><!--/p-col-12-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-12">

                <div class="p-field p-col-12">
                    <label for="fitnessClassContentAr" class="">{{ 'CONTENTAR' | translate }}</label>
                    <ckeditor formControlName="contentAr" [editor]="Editor" id="fitnessClassContentAr" name="contentAr" [config]="editorService.config"></ckeditor>
                </div>

              </div><!--/p-col-12-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-12">

                <div class="p-field p-col-12">
                    <label for="fitnessClassContentFr" class="">{{ 'CONTENTFR' | translate }}</label>
                    <ckeditor formControlName="contentFr" [editor]="Editor" id="fitnessClassContentFr" name="contentFr" [config]="editorService.config"></ckeditor>
                </div>

              </div><!--/p-col-12-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-icons "></i>
                    </span>
                    <span class="p-float-label">
                      <input id="fitnessClassIcon" formControlName="icon" type="text" pInputText [required]="false"> 
                      <label for="fitnessClassIcon" class="">{{ 'ICON' | translate }}</label>
                    </span>
                    <button type="button" pButton pRipple icon="pi pi-folder" styleClass="p-button-info" (click)="openFilerDialog('icon')"></button> 
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-palette"></i>
                    </span>
                    <span class="p-inputgroup-addon" style="max-width: 1em;">
                      <p-colorPicker (onChange)="setColor($event)" formControlName="color"></p-colorPicker>
                    </span>
                    <span class="p-float-label">
                      <input type="text" pInputText id="fitnessClassColor" formControlName="color" [required]="false">
                      <label for="fitnessClassColor" class="p-d-inline-block p-ml-2 ">{{ 'COLOR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-running"></i>
                    </span>
                    <span class="p-float-label">
                      <p-dropdown  inputId="fitnessClassSportId" [autoDisplayFirst]="false" formControlName="sport" [options]="fitnessClassesColumnsService.sports" optionValue="id" optionLabel="name" [required]="true" [filter]="true"></p-dropdown>
                      <label for="fitnessClassSportId" class="req">{{ 'SPORT' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="fitnessClassForm.controls['sport'].invalid && (fitnessClassForm.controls['sport'].dirty || fitnessClassForm.controls['sport'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="fitnessClassForm.controls['sport'].errors !== null">
                  <div *ngIf="fitnessClassForm.controls['sport'].errors.required">
                   {{ 'SPORTREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <p-dropdown  inputId="fitnessClassAgeRangeId" [autoDisplayFirst]="false" formControlName="ageRange" [options]="fitnessClassesColumnsService.ageRanges" optionValue="id" optionLabel="name" [required]="true" [filter]="true"></p-dropdown>
                      <label for="fitnessClassAgeRangeId" class="req">{{ 'AGERANGE' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="fitnessClassForm.controls['ageRange'].invalid && (fitnessClassForm.controls['ageRange'].dirty || fitnessClassForm.controls['ageRange'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="fitnessClassForm.controls['ageRange'].errors !== null">
                  <div *ngIf="fitnessClassForm.controls['ageRange'].errors.required">
                   {{ 'AGERANGEREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-signal"></i>
                    </span>
                    <span class="p-float-label">
                      <p-dropdown  inputId="fitnessClassIntensityId" [autoDisplayFirst]="false" formControlName="intensity" [options]="fitnessClassesColumnsService.intensities" optionValue="id" optionLabel="name" [required]="true" [filter]="true"></p-dropdown>
                      <label for="fitnessClassIntensityId" class="req">{{ 'INTENSITY' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="fitnessClassForm.controls['intensity'].invalid && (fitnessClassForm.controls['intensity'].dirty || fitnessClassForm.controls['intensity'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="fitnessClassForm.controls['intensity'].errors !== null">
                  <div *ngIf="fitnessClassForm.controls['intensity'].errors.required">
                   {{ 'INTENSITYREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-timer"></i>
                    </span>
                    <span class="p-float-label">
                      <p-dropdown  inputId="fitnessClassClassDurationId" [autoDisplayFirst]="false" formControlName="classDuration" [options]="fitnessClassesColumnsService.classDurations" optionValue="id" optionLabel="name" [required]="true" [filter]="true"></p-dropdown>
                      <label for="fitnessClassClassDurationId" class="req">{{ 'CLASSDURATION' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="fitnessClassForm.controls['classDuration'].invalid && (fitnessClassForm.controls['classDuration'].dirty || fitnessClassForm.controls['classDuration'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="fitnessClassForm.controls['classDuration'].errors !== null">
                  <div *ngIf="fitnessClassForm.controls['classDuration'].errors.required">
                   {{ 'CLASSDURATIONREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                    <p-toggleButton inputId="fitnessClassIsPublished" formControlName="isPublished" onIcon="pi pi-check" offIcon="pi pi-times"  [style]="{'width': '2em'}"></p-toggleButton>
                    <label for="fitnessClassIsPublished" class="p-d-inline-block p-ml-2 req">{{ 'ISPUBLISHED' | translate }}</label>
                </div>
                <div *ngIf="fitnessClassForm.controls['isPublished'].invalid && (fitnessClassForm.controls['isPublished'].dirty || fitnessClassForm.controls['isPublished'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="fitnessClassForm.controls['isPublished'].errors !== null">
                  <div *ngIf="fitnessClassForm.controls['isPublished'].errors.required">
                   {{ 'ISPUBLISHEDREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->

            <div class="p-fluid p-grid">
              <div class="p-col-12">
                <label for="fitnessClassFitnessGoals" class="control-label">
                  <span>
                    {{ 'FITNESSGOALS' | translate }}
                  </span>
                  <span class="input-icon">
                    <input placeholder="{{ 'FILTERFITNESSGOALS' | translate }}" type="text" #fitnessGoalsSearchText (input)="fitnessClassesColumnsService.filterFitnessGoals(fitnessGoalsSearchText.value)" class="form-control pull-right input-sm underline" />
                      <i class="icon-filter"></i>
                   </span><!--/input-icon-->
                </label>
              </div><!--/p-col-12-->
              <ng-container *ngFor="let fitnessGoal of fitnessClassesColumnsService.fitnessGoalsFiltered">
                <div class="p-col-3 p-field-checkbox" *ngIf="fitnessGoal.id">
                  <p-checkbox name="fitnessGoals" [formControl]="$any(fitnessClassForm).controls['fitnessGoals']" [value]="fitnessGoal.id" label="{{ fitnessGoal.name }}"></p-checkbox>
                </div><!--/p-col-3-->
              </ng-container>
              <div class="p-col-12">
                <div class="p-field-checkbox">
                  <p-checkbox (onChange)="toggleAllFitnessGoals($event)" id="fitnessClassFitnessGoals" label="{{ 'SELECTALL' | translate }}"></p-checkbox>
                </div><!--/checkbox-->
              </div><!--/p-col-12-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-4">
                <button (click)="list()" class="btn btn-primary pull-left">
                  <i class="icon-layout-list-thumb"></i>
                  <span class="p-ml-1">{{ 'BACKFITNESSCLASSES' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4 text-center">
                <button *ngIf="fitnessClass.id !== null" type="button" (click)="submitForm(false)" class="btn btn-primary" [disabled]="!fitnessClassForm.valid || disableSubmit"> <!--  [disabled]="fitnessClassForm.$invalid" -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && !redirect"></i>
                  <i class="fas fa-check-circle" *ngIf="!(disableSubmit && !redirect)"></i>
                  <span class="p-ml-1"> {{ 'APPLY' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4">
                <button type="button" (click)="submitForm(true)" class="btn btn-primary pull-right" [disabled]="disableSubmit"> <!--  [disabled]="!fitnessClassForm.valid || " -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && redirect"></i>
                  <i class="icon-save" *ngIf="!(disableSubmit && redirect)"></i>
                  <span class="p-ml-1">{{ 'SAVE' | translate }}</span>
                </button>
              </div>
            </div>
          </form>
        </p-fieldset>
        <div class="p-fluid p-grid">
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
          <div class="col-sm-12 p-col-4 mb-2 text-center">
          </div>
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
        </div>
      </div>
    </div><!--/p-col-12-->
  </div><!--/p-fluid p-grid-->
  <p-scrollTop target="parent"></p-scrollTop>
</div><!--/container-fluid container-fullw-->
<!-- end: FORM -->

